// @ts-nocheck
import { Trans } from '@lingui/react'
import classNames from 'clsx'

import { OFFER_PROMOTION_TYPES } from 'shared/consts/marketplace'

const renderLinkToDetailPage = productType =>
  productType !== OFFER_PROMOTION_TYPES.FREEBIE

const ProductNameAndPrescriptionDate = ({
  productId,
  productName,
  mountPoints,
  prescriptionDate,
  productType,
  isERx,
  cartFreeGiftPromotionExperimentV1,
}) => (
  <>
    {productName && renderLinkToDetailPage(productType) && !isERx && (
      <a
        href={mountPoints.getProductUrl(productName, productId)}
        className="u-font-weight--bold u-color--dark o-ProductInfo__title"
      >
        {productName}
      </a>
    )}
    {prescriptionDate && (
      <div className="u-font-weight--bold">
        <Trans
          id="general.label.prescriptionDate"
          values={{ prescriptionDate }}
        />
      </div>
    )}
    {!prescriptionDate && isERx && (
      <div className="u-font-weight--bold">
        <Trans id="general.label.ereceipt" />
      </div>
    )}
    {productName && (!renderLinkToDetailPage(productType) || isERx) && (
      <span
        className={classNames({
          'u-font-weight--bold': !isERx,
          'u-font-weight-rebranding--medium package-size':
            !isERx && cartFreeGiftPromotionExperimentV1,
        })}
      >
        {productName}
      </span>
    )}
  </>
)

export default ProductNameAndPrescriptionDate
